<template>
  <fullscreen
    v-model="fullscreen"
    :class="{ white: fullscreen }"
    style="overflow: auto; height: 100%"
    class="d-flex flex-column"
  >
    <div class="pa-2">
      <div v-if="!fullscreen" class="mb-1">
        <span class="ml-1 font-weight-medium"> สถานะ Device </span>
      </div>
      <v-card outlined class="px-2 py-1">
        <div class="d-flex justify-space-between align-center">
          <div>
            <v-btn icon @click="setFullscreen">
              <v-icon size="36" v-if="!fullscreen">mdi-fullscreen</v-icon>
              <v-icon size="36" v-else>mdi-fullscreen-exit</v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center">
            <div class="mb-1">
              <label class="caption ml-1">ค้นหา</label>
              <v-text-field
                v-model="search"
                placeholder="ค้นหา Device"
                prepend-inner-icon="mdi-magnify"
                clearable
                flat
                outlined
                dense
                hide-details
                style="width: 200px; padding: 0 5px"
              ></v-text-field>
            </div>
            <div>
              <label class="caption ml-1 d-block">ตัวกรอง: พื้นที่</label>
              <v-dialog
                v-model="dialogAreas"
                scrollable
                max-width="420px"
                persistent
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="text-capitalize"
                    height="40"
                    elevation="1"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-filter</v-icon>
                    เลือกดูเฉพาะพื้นที่
                    <v-avatar class="ml-2" color="primary" size="24">
                      <span class="white--text subtitle-2">
                        {{ selectedAreas === null ? 0 : selectedAreas.length }}
                      </span>
                    </v-avatar>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <v-checkbox
                      v-model="selectedAreasAll"
                      label="เลือกทั้งหมด"
                      :indeterminate="
                        selectedAreas.length > 0 &&
                        selectedAreas.length < filterAreas.length
                      "
                      @change="handleSelectedAreasAll"
                      hide-details
                      class="mt-0 mb-2"
                    ></v-checkbox>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text style="height: 300px">
                    <v-text-field
                      v-model="searchAreas"
                      outlined
                      dense
                      hide-details
                      prepend-inner-icon="mdi-magnify"
                      class="mt-4"
                    ></v-text-field>
                    <div>
                      <v-checkbox
                        v-model="selectedAreas"
                        v-for="item in filterAreas.sort((a, b) =>
                          a.area.localeCompare(b.area)
                        )"
                        :key="item.area"
                        :label="item.area === 'undefined' ? '-' : item.area"
                        :value="item.area"
                        hide-details
                      ></v-checkbox>
                    </div>
                    <div
                      v-if="filterAreas.length === 0"
                      class="text-center py-4"
                    >
                      {{ filterAreas.length === 0 ? 'ไม่พบข้อมูล' : '' }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogAreas = false"
                    >
                      ตกลง
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </div>
      </v-card>
      <v-card outlined class="mt-2 px-4 py-2">
        <div class="d-flex align-center">
          <span class="font-weight-medium"> สถานะ </span>
          <div class="d-flex align-center ml-4">
            <v-btn
              text
              small
              color="primary"
              :disabled="checkedStatus.length === 2"
              @click="checkedStatus = ['connected', 'disconnected']"
              >เลือกทั้งหมด</v-btn
            >
            <div
              style="
                width: 1px;
                height: 15px;
                background-color: #e0e0e0;
                display: inline-block;
              "
            ></div>
            <v-btn
              text
              small
              color="primary"
              :disabled="checkedStatus.length === 0"
              @click="checkedStatus = []"
              >ล้างทั้งหมด</v-btn
            >
          </div>
        </div>
        <div class="mt-1">
          <div
            style="border: 1px solid #4caf50"
            class="px-2 py-1 d-inline-block rounded"
          >
            <input
              type="checkbox"
              id="connected"
              value="connected"
              v-model="checkedStatus"
            />
            <label for="connected" class="ml-2 body-2 grey--text text--darken-3"
              >Connected</label
            >
          </div>
          <div
            style="border: 1px solid #f44336"
            class="ml-2 px-2 py-1 d-inline-block rounded"
          >
            <input
              type="checkbox"
              id="disconnected"
              value="disconnected"
              v-model="checkedStatus"
            />
            <label
              for="disconnected"
              class="ml-2 body-2 grey--text text--darken-3"
              >Disconnected</label
            >
          </div>
        </div>
      </v-card>
    </div>
    <div class="px-2">
      <v-data-table
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        :loading="loading"
        loading-text="Loading... Please wait"
        :search="search"
        :headers="headers"
        :items="hardwareStatus"
        :items-per-page="-1"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50, 100, -1],
          itemsPerPageText: 'Rows per page:',
        }"
        hide-default-footer
        :custom-filter="filterHardwareStatus"
      >
        <template v-slot:item.area="{ item }">
          <span v-if="item.area === 'undefined'">-</span>
          <span v-else>{{ item.area }}</span>
        </template>
        <template v-slot:item.hardware_status="{ item }">
          <v-chip
            v-for="hardware in item.hardwares"
            :key="hardware.hardware_uuid"
            :color="hardware.is_connect ? 'green' : 'red'"
            class="mr-2 my-1"
            outlined
            text-color="#424242"
            small
          >
            <span
              v-if="hardware.title_th"
              style="font-size: 12px; color: #616161"
            >
              {{ hardware.title_th }}
            </span>
            <span
              v-else
              style="font-size: 12px; font-weight: 600; color: #424242"
              >ไม่มีชื่อ
            </span>
          </v-chip>
        </template>
      </v-data-table>
    </div>
  </fullscreen>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      checkedStatus: [],
      websocketReconnectCount: 0,
      searchAreas: '',
      selectedAreas: [],
      dialogAreas: false,
      websocket: null,
      fullscreen: false,
      sortBy: ['area'],
      sortDesc: [false],
      loading: false,
      search: '',
      headers: [
        {
          text: 'พื้นที่',
          align: 'start',
          value: 'area',
          width: 280,
        },
        { text: 'สถานะ Device', sortable: false, value: 'hardware_status' },
      ],
      areas: [],
    }
  },
  computed: {
    selectedAreasAll: {
      set(val) {
        this.selectedAreas = []
        if (val) {
          for (let i = 1; i <= this.filterAreas.length; i++) {
            this.selectedAreas.push(i)
          }
        }
      },
      get() {
        return this.selectedAreas.length === this.filterAreas.length
      },
    },
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
    hardwareStatus() {
      const results = _.chain(this.hardwares)
        // Group the elements of Array based on `area.title_th` property
        .groupBy('area.title_th')
        // `key` is group's name (area.title_th), `value` is the array of objects
        .map((value, key) => ({ area: key, hardwares: value }))
        .value()
        .map((item) => {
          return {
            area: item.area,
            hardwares: item.hardwares
              .filter((hardware) => {
                if (this.checkedStatus.length === 0) {
                  return true
                }

                return this.checkedStatus.includes(
                  hardware.is_connect ? 'connected' : 'disconnected'
                )
              })
              .filter((hardware) => {
                return hardware.title_th
                  .toLowerCase()
                  .includes(this.search.toLowerCase())
              })
              .sort((a, b) => {
                return a.title_th.localeCompare(b.title_th)
              }),
          }
        })
        .filter((item) => {
          if (this.selectedAreas.length === 0) {
            return true
          }

          return this.selectedAreas.includes(item.area)
        })
      return results
    },
    filterAreas() {
      return this.areas.filter((item) => {
        return item.area.toLowerCase().includes(this.searchAreas.toLowerCase())
      })
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สถานะ Device',
        disabled: true,
      },
    ])

    try {
      const { company_uuid } = this.$store.state.authentication.company

      this.$store.state.loading = true

      const payload = {
        params: {
          dpc: 'monitor-hardware-status-to-list-hardware',
          company_uuid,
        },
      }
      await this.fetchHardwares(payload)

      this.areas = this.hardwareStatus.map((item) => {
        return { area: item.area }
      })

      localStorage.removeItem('logs')
      this.connectWebsocket()
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.$store.state.loading = false
    }
  },
  methods: {
    ...mapActions({
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    filterHardwareStatus(value, search, item) {
      return (
        item.area.toLowerCase().includes(search.toLowerCase()) ||
        item.hardwares.some((hardware) =>
          hardware.title_th.toLowerCase().includes(search.toLowerCase())
        )
      )
    },
    handleSelectedAreasAll(value) {
      if (value) {
        this.selectedAreas = this.areas.map((item) => item.area)
      } else {
        this.selectedAreas = []
      }
    },
    localStorageSetItem(message) {
      localStorage.setItem(
        'logs',
        JSON.stringify([
          ...(localStorage.getItem('logs')
            ? JSON.parse(localStorage.getItem('logs'))
            : []),
          message,
        ])
      )
    },
    connectWebsocket() {
      this.localStorageSetItem(
        `call function connect websocket :: ${new Date()}`
      )

      const { company_uuid } = this.$store.state.authentication.company

      if (this.websocket) {
        this.localStorageSetItem(`clear old websocket :: ${new Date()}`)

        this.websocket.close()
      }

      this.localStorageSetItem(
        `Starting Connection to WebSocket Server :: ${new Date()}`
      )

      this.websocket = new WebSocket(
        process.env.VUE_APP_API_WEB_SOCKET_ENDPOINT
      )

      this.websocket.onopen = () => {
        this.localStorageSetItem(
          `Successfully connected to the echo WebSocket Server :: ${new Date()}`
        )

        // SEND MESSAGE TOPIC
        this.sendMessage({
          scope: `${process.env.VUE_APP_REALTIME_ENV_SCOPE}:${company_uuid}`,
          topic: 'hardware_status',
        })
      }

      this.websocket.onmessage = (event) => {
        const data = JSON.parse(event?.data)
        const hardware = JSON.parse(data?.payload)
        const hardwares = this.$store.state.hardware.hardwares.map((item) => {
          if (item.hardware_uuid === hardware.hardware_uuid) {
            return {
              ...item,
              is_connect: hardware.is_connect,
            }
          } else {
            return item
          }
        })
        this.$store.commit('hardware/SET_HARDWARES', hardwares)
      }

      this.websocket.onclose = (event) => {
        this.localStorageSetItem(`${event} :: ${new Date()}`)

        if (event.wasClean) {
          this.localStorageSetItem(
            `[close] Connection closed cleanly, code=${event.code} reason=${
              event.reason
            } :: ${new Date()}`
          )
        } else {
          // e.g. server process killed or network down
          // event.code is usually 1006 in this case
          this.localStorageSetItem(
            `${
              window?.navigator?.onLine ? 'online' : 'offline'
            } :: ${new Date()}`
          )

          this.localStorageSetItem(`[close] Connection died :: ${new Date()}`)

          this.handleReconnectWebsocket(this)
        }
      }

      this.websocket.onerror = (error) => {
        this.localStorageSetItem(`[error] ${error} :: ${new Date()}`)
      }
    },
    handleReconnectWebsocket: _.debounce((self) => {
      self.localStorageSetItem(
        `call handle reconnect websocket :: ${new Date()}`
      )

      self.websocketReconnectCount += 1

      if (self.websocketReconnectCount <= 3) {
        self.localStorageSetItem(
          `reconnect websocket : ${
            self.websocketReconnectCount
          } :: ${new Date()}`
        )

        self.connectWebsocket()
      } else {
        self.localStorageSetItem(`refresh page :: ${new Date()}`)

        // refresh page
        self.$router.go(0)
      }
    }, 1000),
    sendMessage(message) {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(message))
      }
    },
    setFullscreen() {
      this.fullscreen = !this.fullscreen
    },
  },
  beforeDestroy() {
    this.websocket.close()
    this.websocket = null
  },
}
</script>
